import type { EventId } from '@ps/isp-web-services-types';
import React from 'react';
import { useSelector } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { Event } from '@swf/sports/components/Event/Event';
import { useEventMarketTemplatesWidget } from '@swf/sports/models/market-templates/eventBased';

export interface Props {
  eventId: EventId;
}

const EventMoreMarkets: React.FC<Props> = ({ eventId }) => {
  const { widgetSelect } = useEventMarketTemplatesWidget();
  const event = useSelector((state: RootState) => widgetSelect.event(state, eventId));

  if (!event.competitionId) return null;

  return (
    <li data-testid="event">
      <Event event={event} />
    </li>
  );
};

export default EventMoreMarkets;
